// src/models/UnitTypes.js

// Unit type data
export const UNIT_TYPES = {
    'pawn': {
      name: "Pawn",
      emoji: "♟️",
      hp: 300,
      attack: 15,
      defense: 1,
      range: 20,
      speed: 2.8,
      tier: 1,
      type: "Melee",
      description: "Fast melee unit with low damage but decent health."
    },
    'footman': {
      name: "Footman",
      emoji: "🛡️",
      hp: 450,
      attack: 22,
      defense: 4,
      range: 25,
      speed: 1.8,
      tier: 2,
      type: "Melee",
      description: "Balanced infantry unit with good health and damage."
    },
    'archer': {
      name: "Archer",
      emoji: "🏹",
      hp: 320,
      attack: 35,
      defense: 1,
      range: 200,
      speed: 1.5,
      tier: 3,
      type: "Ranged",
      description: "Ranged attacker with high damage but low health."
    },
    'torch': {
      name: "Torch Swinger",
      emoji: "🔥",
      hp: 380,
      attack: 28,
      defense: 2,
      range: 30,
      speed: 2.2,
      type: "Melee",
      description: "Enemy melee unit that counters archers."
    },
    'bombardCrew': {
      name: "Bombard Crew",
      emoji: "💣",
      hp: 280,
      attack: 40,
      defense: 1,
      range: 180,
      speed: 1.2,
      type: "Siege",
      description: "Enemy siege unit that throws explosives."
    },
    'barrel': {
      name: "Explosive Barrel",
      emoji: "🛢️",
      hp: 200,
      attack: 25,
      defense: 0,
      range: 15,
      speed: 1.6,
      type: "Siege",
      description: "Kamikaze unit that deals area damage on death."
    },
    'woodtower': {
      name: "Wood Tower",
      emoji: "🗼",
      hp: 800,
      attack: 30,
      defense: 6,
      range: 250,
      speed: 0,
      type: "Structure",
      description: "Enemy defensive structure with high health and good range.",
      isStructure: true
    }
  };
  
  // Function to create a unit with the correct type data
  export function createUnit(unitKey, team, x, y, Unit) {
    const unit = new Unit(unitKey, team, x, y);
    
    // Apply type-specific data
    if (UNIT_TYPES[unitKey]) {
      const typeData = UNIT_TYPES[unitKey];
      unit.name = typeData.name;
      unit.emoji = typeData.emoji;
      unit.health = typeData.hp;
      unit.maxHealth = typeData.hp;
      unit.damage = typeData.attack;
      unit.defense = typeData.defense;
      unit.range = typeData.range;
      unit.speed = typeData.speed;
      unit.type = typeData.type;
      unit.isStructure = typeData.isStructure || false;
      
      // Structures don't move
      if (unit.isStructure) {
        unit.speed = 0;
      }
    }
    
    return unit;
  }
  
  // Get available player units (for unit selection)
  export function getPlayerUnits() {
    return {
      'pawn': UNIT_TYPES['pawn'],
      'footman': UNIT_TYPES['footman'],
      'archer': UNIT_TYPES['archer']
    };
  }